import React, { useEffect, useState } from 'react'
import Nlayout from './Nlayout'
import { Alert, Box, Button, CircularProgress, Grid, Link, Paper, Step, StepLabel, Stepper, TextField, Typography, styled } from '@mui/material'
import { Dialog } from "@mui/material";
import { FaCloudUploadAlt } from "react-icons/fa";
import { getEnhancedFingerprint } from './fingerprint';

import backgroundImg from './main_intro.jpg'
import axios from 'axios'

import paso1 from './img/paso1bonus.jpeg'

import paso1xbet from './img/paso1xbet.jpeg'
import paso2xbet from './img/paso2xbet.jpeg'
import paso3xbeta from './img/paso3beta.jpeg'
import paso3xbetb from './img/paso3betb.jpeg'
import paso4xbeta from './img/paso4xbeta.jpeg'
import paso4xbetb from './img/paso4xbetb.jpeg'
import paso5xbeta from './img/paso5xbeta.jpeg'
import paso5xbetb from './img/paso5xbetb.jpeg'
import paso5xbetc from './img/paso5xbetc.jpeg'
import paso6xbeta from './img/paso6xbeta.jpeg'
import paso6xbetb from './img/paso6xbetb.jpeg'
import paso7xbeta from './img/paso7xbeta.jpeg'
import paso7xbetb from './img/paso7xbetb.jpeg'
import tipeoextra from './img/tipeoextraBw.png'
import paso2 from './Paso2-gif.gif'
import paso3 from './Paso3-gif.gif'
import vault from './vault.jpg'
import ej2 from './ejpaso2.jpg'
import ej3 from './ejpaso3.jpg'
import successImg from './withdraw.jpg'
import paso1betwin from './img/paso1bet.jpeg'
import paso2betwin from './img/paso2bet.jpeg'
import paso3betwin from './img/depostiobetw.jpeg'
import paso3betwinnuevo from './img/paso2betnuuevo.jpeg'
import paso4betwinnuevo from './img/paso3betnuevo.jpeg'
import paso11 from './img/PASO11.jpeg'

import paso1bono from './img/paso1.jpeg'
import paso2bono from './img/paso2.jpeg'
import paso3bono from './img/paso3.jpeg'
import paso4bono from './img/paso4.jpeg'
import paso5bono from './img/paso5.jpeg'
import { BrowserQRCodeReader } from '@zxing/browser'

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const StepWrapper = ({ images, instruction, children }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, height: '100%', justifyContent: 'space-between' }}>
            {images && (
                <Box
                    sx={{
                        flex: '0 0 230px',
                        height: '230px',
                        background: 'linear-gradient(135deg, #0d2818 0%, #05100a 100%)',
                        borderRadius: '12px',
                        border: '1px solid #164e2b',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 1.5,
                        width: '80%',
                        margin: '0 auto',
                        position: 'relative',
                        boxShadow: 'inset 0 0 25px rgba(0,0,0,0.8), 0 4px 12px rgba(0,0,0,0.5)',
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            top: 0, right: 0, bottom: 0, left: 0,
                            background: 'radial-gradient(circle, transparent 40%, rgba(0,0,0,0.4) 100%)',
                            pointerEvents: 'none',
                        },
                        '& img': {
                            height: '100%',
                            width: 'auto',
                            maxHeight: '100%',
                            maxWidth: '100%',
                            objectFit: 'contain',
                            borderRadius: '8px',
                        }
                    }}
                >
                    {images}
                </Box>
            )}
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: 2,
                }}
            >
                {instruction && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 2,
                            backgroundColor: 'rgba(30, 41, 59, 0.5)',
                            p: 2,
                            borderRadius: '10px',
                            borderLeft: '4px solid #3b82f6',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                            border: '1px solid rgba(255, 255, 255, 0.05)',
                            borderLeftWidth: '4px',
                            borderLeftColor: '#3b82f6',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '28px',
                                height: '28px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(59, 130, 246, 0.15)',
                                color: '#3b82f6',
                                fontWeight: 'bold',
                                fontSize: '15px',
                                flexShrink: 0,
                                border: '1px solid rgba(59, 130, 246, 0.3)',
                                mt: '2px',
                                boxShadow: '0 0 6px rgba(59, 130, 246, 0.2)',
                            }}
                        >
                            i
                        </Box>
                        <Box sx={{ flex: 1 }}>
                            {instruction}
                        </Box>
                    </Box>
                )}
                {children}
            </Box>
        </Box>
    );
};


function BetWinner(props) {
    const getSafeLocalStorage = (key) => {
        try {
            return localStorage.getItem(key);
        } catch (e) {
            console.warn("localStorage is not accessible:", e);
            return null;
        }
    };

    const setSafeLocalStorage = (key, value) => {
        try {
            localStorage.setItem(key, value);
        } catch (e) {
            console.warn("localStorage set failed:", e);
        }
    };

    const [userEmail, setUserEmail] = useState('');
    const mailKick = getSafeLocalStorage('kick_mail')
    const [solicitudes, setSolicitudes] = useState()
    const [cargar, setCargar] = useState()
    const nombre = getSafeLocalStorage('kick_user')
    const [isWinner, setIsWinner] = useState()
    // Estados para el modal
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [triggerUpload, setTriggerUpload] = useState(null);
    const checkWinner = async () => {
        setCargar(true)
        try {
            const peticion = await axios.post(`https://backend.eldenguee.com/sorteo/check-ganador`, { nombre })
            const peticionTipeo = await axios.post(`https://backend.eldenguee.com/solicitudes/tipeo`, { nombre })
            const soli = Array.isArray(peticionTipeo?.data)
                ? peticionTipeo.data.map((p) => p.solicitudes)
                : [0];
            setSolicitudes(soli)
            setIsWinner(peticion?.data)
            setUserEmail(mailKick)
        } catch (error) {
            console.error("Error en checkWinner:", error);
            setSolicitudes([0]);
        } finally {
            setCargar(false)
        }
    }


    useEffect(() => { checkWinner() }, [])

    const [activeStep, setActiveStep] = useState(0);
    const [offerScreenshot, setOfferScreenshot] = useState(null);
    const [bnbScreenshot, setBnbScreenshot] = useState(null);
    const [bnbAddress, setBnbAddress] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [offerScreenshotUrl, setOfferScreenshotUrl] = useState('');
    const [bnbScreenshotUrl, setBnbScreenshotUrl] = useState('');
    const [url, setUrl] = useState('')



    const handleNext = () => {
        if (validateStep()) {
            setError('');
            setActiveStep((prev) => prev + 1);
        }
    };

    const handleBack = () => {
        setError('');
        setActiveStep((prev) => prev - 1);
    };

    const validateStep = () => {

        if (activeStep === 6 && (!bnbAddress)) {

            setError('Debes escribir la direccion BNB');
            return false;
        }

        return true;
    };

    const [deshabilitarBoton, setDeshabilitarBoton] = useState(false)
    const [fingerprint, setFingerprint] = useState('');
    // Función para obtener el fingerprint mejorado
    const getFingerprint = async () => {
        try {
            const visitorId = await getEnhancedFingerprint();

            console.log('✅ Enhanced Fingerprint ID:', visitorId);
            setFingerprint(visitorId);

            // Guardamos también en localStorage como respaldo
            setSafeLocalStorage('userFingerprint_v2', visitorId);

            return visitorId;
        } catch (error) {
            console.error('❌ Error generando fingerprint:', error);
            return null;
        }
    };
    // Obtenemos el fingerprint al montar el componente
    useEffect(() => {
        getFingerprint();
    }, []);
    // Función auxiliar para obtener fingerprint (usa el estado o localStorage)
    const getOrCreateFingerprint = async () => {
        if (fingerprint) return fingerprint;

        const saved = getSafeLocalStorage('userFingerprint_v2');
        if (saved) {
            setFingerprint(saved);
            return saved;
        }

        return await getFingerprint();
    };
    const getPublicIP = async () => {
        const res = await fetch('https://api.ipify.org?format=json');
        const data = await res.json();
        return data.ip;
    };
    const steps = ['Paso 1', 'Paso 2', 'Paso 3', 'Paso 4', 'Paso 5', 'Paso 6', 'Paso 7', 'Paso 8', 'Paso 9', 'Paso 10', 'Paso 11'];
    // ==================== NUEVA FUNCIÓN DE SUBIDA (Proxy) ====================
    const uploadToServer = async (file) => {
        if (!file || !(file instanceof File)) {
            throw new Error('Archivo inválido');
        }

        const formData = new FormData();
        formData.append('imagen', file);   // ← Nombre del campo que espera tu backend

        const response = await fetch('https://backend.eldenguee.com/solicitudes/upload', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || 'Error al subir la imagen');
        }

        const data = await response.json();
        return data.url || data.fileUrl || data.filename; // Ajusta según lo que devuelva tu backend
    };
    // =========================================================================

    // Manejar cambio de archivo y subir a Cloudinary
    const handleFileChange = (setFile, setUrl) => async (event) => {
        const file = event.target.files[0];
        if (file) {
            setFile(file);
            try {
                setIsUploading(true);
                const url = await uploadToServer(file);
                setUrl(url);
                setError('');
            } catch (err) {
                setError('Error al subir la imagen: ' + err.message);
            } finally {
                setIsUploading(false);
            }
        }
    };
    const handleRequestTipeo = async () => {
        if (loading || deshabilitarBoton) return;
        setLoading(true);
        setError('');
        const ip = await getPublicIP();
        const fp = await getOrCreateFingerprint();

        try {
            if (!bnbAddress.startsWith('0x')) {
                throw new Error('UPS! eso no parece una dirección BNB');
            }
            if (activeStep === 2 && (
                bnbAddress?.toLowerCase() === '0x3f1bD53eB8A3F5d60147A5C0c47279a...' ||
                bnbAddress?.toLowerCase() === '0x3f1bD53eB8A3F5d60147A5C0c47279a'
            )) {
                setError('La dirección BNB debe ser una real..');
                return false;
            }

            if (!bnbAddress) {
                throw new Error('Todos los campos son obligatorios');
            }

            setDeshabilitarBoton(true)

            // Subir imágenes al servidor propio (proxy)
            const offerScreenshotUrl = await uploadToServer(offerScreenshot);

            // Enviar solicitud al backend
            const response = await fetch('https://backend.eldenguee.com/solicitudes/submit-request', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    nombre: localStorage.getItem('kick_user'),
                    offerScreenshot: offerScreenshotUrl,
                    bnbScreenshot: 'bnbScreenshotUrl',
                    bnbAddress,
                    ip,
                    fingerprint: fp,
                    casino: 'BetWinner'
                }),
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Error al enviar la solicitud');
            }

            setSuccess(true);
        } catch (err) {
            setError('Error: ' + err.message);
        } finally {
            setLoading(false);
            setDeshabilitarBoton(false)
        }
    };

    const [isUploading, setIsUploading] = useState(false);



    const [isOpen, setIsOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const openImage = (url) => {
        setSelectedImage(url);
        setIsOpen(true);
    };

    const closeImage = () => {
        setIsOpen(false);
        setSelectedImage(null);
    };

    const getStepContent = (step) => {
        switch (step) {
            case 1:
                return (
                    <StepWrapper
                        images={<img src={paso2betwin} alt="Paso 2" />}
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.4', color: '#cbd5e1' }}>
                                Una vez registrado te mostrará los datos de tu cuenta, puedes guardarlos para no olvidarlos.
                            </Typography>
                        }
                    />
                );
            case 2:
                return (
                    <StepWrapper
                        images={<img src={paso3betwinnuevo} alt="Paso 3" />}
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.4', color: '#cbd5e1' }}>
                                Ingresar a tu perfil apretando el icono superior de la derecha y luego ir a la parte de Datos Personales. Como figura en la imagen
                            </Typography>
                        }
                    />
                );
            case 3:
                return (
                    <StepWrapper
                        images={<img src={paso4betwinnuevo} alt="Paso 4" />}
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.4', color: '#cbd5e1' }}>
                                Subir una captura de lo que te muestra en datos personales como figura en la imagen de ejemplo.
                            </Typography>
                        }
                    >
                        <Box
                            sx={{
                                backgroundColor: 'rgba(30, 41, 59, 0.4)',
                                borderRadius: 2,
                                p: 1.5,
                                color: '#cbd5e1',
                                border: '1px dashed #334155',
                                mt: 1,
                            }}
                        >
                            <Box
                                sx={{
                                    borderBottom: '1px solid #334155',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    pb: 1,
                                    mb: 1,
                                    fontWeight: 'bold',
                                }}
                            >
                                <Typography variant="body2">Tu imagen</Typography>
                                <Typography variant="body2" sx={{ color: '#94a3b8' }}>
                                    {offerScreenshot ? `Archivo: ${offerScreenshot.name}` : 'No hay archivo'}
                                </Typography>
                            </Box>
                            {isUploading ? (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60px' }}>
                                    <CircularProgress size={24} color="inherit" />
                                </Box>
                            ) : (
                                offerScreenshotUrl && (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                                        <img src={offerScreenshotUrl} style={{ maxHeight: '60px', maxWidth: '100%', borderRadius: '4px' }} alt="Preview" />
                                    </Box>
                                )
                            )}
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                            <Button
                                component="label"
                                variant="contained"
                                startIcon={<FaCloudUploadAlt />}
                                sx={{
                                    backgroundColor: '#334155',
                                    color: '#fff',
                                    flex: 1,
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    py: 1,
                                    '&:hover': {
                                        backgroundColor: '#475569',
                                    },
                                }}
                                onClick={() => {
                                    setTriggerUpload(() => () =>
                                        document.getElementById('bnbScreenshotInput').click()
                                    );
                                    setShowWarningModal(true);
                                }}
                            >
                                Cargar imagen
                            </Button>
                            <VisuallyHiddenInput
                                id="bnbScreenshotInput"
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange(setOfferScreenshot, setOfferScreenshotUrl)}
                            />
                        </Box>
                    </StepWrapper>
                );
            case 0:
                return (
                    <StepWrapper
                        images={<img src={paso1betwin} alt="Paso 1" />}
                        instruction={
                            <>
                                <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.4', color: '#cbd5e1' }}>
                                    Para reclamar tu tipeo SI o SI tienes que registrarte en BETWINNER con el link que figura abajo y MUY importante ingresar el código promocional <strong>"ELDENGUEE"</strong>.
                                    <br /><br />
                                    Podes utilizar la opción de un clic para registrarte si asi lo deseas.
                                    <br /><br />
                                    Si ya tienes una cuenta con el código de <strong>"ELDENGUEE"</strong> no hace falta que te registres denuevo, puedes utilizar esa misma cuenta.
                                </Typography>
                                <Link
                                    href="https://bvwdcuyr2ogy.top/22jq?p=%2Fregistration%2F"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    sx={{
                                        display: 'inline-block',
                                        mt: 1.5,
                                        color: '#4ade80',
                                        wordBreak: 'break-all',
                                        fontWeight: 'bold',
                                        textDecoration: 'none',
                                        '&:hover': {
                                            textDecoration: 'underline',
                                        }
                                    }}
                                >
                                    https://bvwdcuyr2ogy.top/22jq?p=%2Fregistration%2F
                                </Link>
                            </>
                        }
                    />
                );
            case 4:
                return (
                    <StepWrapper
                        images={<img src={paso3xbeta} alt="Paso 5" />}
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.4', color: '#cbd5e1' }}>
                                Tienes que descargar la billetera virtual <strong style={{ color: '#a3e635' }}>LEMON</strong> para recibir el dinero! Si ya la tienes descargada solo clickea en siguiente!
                            </Typography>
                        }
                    />
                );
            case 5:
                return (
                    <StepWrapper
                        images={
                            <Box sx={{ display: 'flex', gap: 2, height: '100%', width: '100%', justifyContent: 'center' }}>
                                <img src={paso4xbeta} alt="Paso 6 A" />
                                <img src={paso4xbetb} alt="Paso 6 B" />
                            </Box>
                        }
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.4', color: '#cbd5e1' }}>
                                Una vez estés dentro de <strong style={{ color: '#a3e635' }}>LEMON</strong> tienes que clickear en <strong style={{ textDecoration: 'underline' }}>Depositar</strong> y tienes que seleccionar la opcion <strong style={{ textDecoration: 'underline' }}>Crypto</strong>
                            </Typography>
                        }
                    />
                );
            case 6:
                return (
                    <StepWrapper
                        images={
                            <Box sx={{ display: 'flex', gap: 1, height: '100%', width: '100%', justifyContent: 'center' }}>
                                <img src={paso5xbeta} alt="Paso 7 A" />
                                <img src={paso5xbetb} alt="Paso 7 B" />
                                <img src={paso5xbetc} alt="Paso 7 C" />
                            </Box>
                        }
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.4', color: '#cbd5e1' }}>
                                Buscas la crypto BNB das click, elegis la red <strong style={{ color: '#a3e635' }}>Bnb Chain (BEP 20)</strong> y Pega acá abajo la dirección que te muestra la aplicación (recomiendo usar la opción de copiar dirección que tiene la misma aplicación de LEMON para evitar problemas)
                            </Typography>
                        }
                    >
                        <TextField
                            fullWidth
                            value={bnbAddress}
                            onChange={(e) => setBnbAddress(e.target.value)}
                            variant="outlined"
                            placeholder='0x...'
                            sx={{
                                mt: 1,
                                backgroundColor: '#0c1b26',
                                borderRadius: '8px',
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: '#2c4454',
                                    },
                                    '&:hover fieldset': {
                                        borderColor: '#3e5d6f',
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#5da6d6',
                                    },
                                    input: {
                                        color: 'white',
                                        padding: '10px 14px',
                                    },
                                },
                            }}
                        />
                    </StepWrapper>
                );

            case 7:
                return (
                    <StepWrapper
                        images={<img src={paso6xbeta} alt="Paso 8" />}
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.4', color: '#cbd5e1' }}>
                                Cuando tu solicitud se confirme te llegará un correo confirmando tu deposito en tu cuenta de Lemon (Puedes ver tu saldo en la parte Portfolio). Apenas te llegue el correo podrás reclamar tu tipeo extra!.
                                <br /><br />
                                Click en Siguiente para terminar tu solicitud
                            </Typography>
                        }
                    />
                );

            case 8:
                return (
                    <StepWrapper
                        images={
                            <Box sx={{ display: 'flex', gap: 1, height: '100%', width: '100%', justifyContent: 'center' }}>
                                <img src={paso6xbetb} alt="Paso 9 A" />
                                <img src={paso7xbeta} alt="Paso 9 B" />
                                <img src={paso7xbetb} alt="Paso 9 C" />
                            </Box>
                        }
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.4', color: '#cbd5e1' }}>
                                Una vez acreditado el saldo vas a la parte de Inicio y pones "Usar", seleccionas <strong style={{ color: '#a3e635' }}>Vender Crypto</strong> Y Seleccionas la moneda <strong style={{ color: '#eab308' }}>BNB</strong> y pones el máximo disponible (podes apretar lo que dice Max y lo hace automáticamente) abajo seleccionas <strong>Peso Argentino</strong>, continuas y confirmas!
                            </Typography>
                        }
                    />
                );
            case 9:
                return (
                    <StepWrapper
                        images={<img src={paso3betwin} alt="Paso 10" />}
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.4', color: '#cbd5e1' }}>
                                <strong style={{ fontWeight: 800 }}>DEPOSITAR EN BETWINNER</strong> con el método de transferencia bancaria
                            </Typography>
                        }
                    />
                );
            case 10:
                return (
                    <StepWrapper
                        images={<img src={paso11} alt="Paso 11" />}
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.4', color: '#cbd5e1' }}>
                                Recuerda sacar una captura del deposito en tu cuenta de <strong style={{ fontWeight: 800 }}>BETWINNER</strong> (mostrando la fecha de carga) para poder <strong style={{ color: '#a3e635' }}>RECLAMAR UN TIPEO EXTRA!</strong>
                            </Typography>
                        }
                    />
                );
            default:
                return null;
        }
    };


    const redirectHome = () => {
        window.location.href = '/'
    }
    return (
        <Nlayout>
            <Grid style={{ background: '#11111d', width: '100%' }}>

                {
                    cargar ?
                        <Grid style={{
                            backgroundImage: `
                                      linear-gradient(to bottom, rgba(63, 61, 69, 0.8), rgba(63, 61, 69, 0)),
                                      url(${backgroundImg})
                                      `,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: '#3f3d45',
                            margin: '0 auto',
                            position: 'relative',
                            backgroundPosition: '50%'
                        }}>
                            <Grid className='container' style={{
                                padding: 50,
                                gap: '10px',
                                justifyContent: 'center',
                                overflow: 'scroll'
                            }}>
                                <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 15 }}>
                                    <Typography style={{ color: 'white', fontWeight: 'bold', fontSize: '32px', fontFamily: 'Outfit,sans-serif' }} >
                                        eldenguee.com
                                    </Typography>
                                    <Typography sx={{
                                        background: 'linear-gradient(317deg,#b58a1b 4.52%,#e0c060 34.37%,#ffeeb2 50.47%,#ffe77c 65.63%,#ffca41 110.56%)',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        fontWeight: 'bold',
                                        fontSize: props.isMobile ? 32 : 65,
                                        fontFamily: 'Belerofonte'
                                    }} >Verificando..</Typography>
                                </Grid>

                                <Grid style={{ display: 'flex', alignItems: 'center', gap: '10px' }} >

                                </Grid>
                            </Grid>
                        </Grid>

                        :

                        solicitudes < 1 ?

                            <Grid style={{
                                backgroundImage: `
                        linear-gradient(to bottom, rgba(63, 61, 69, 0.8), rgba(63, 61, 69, 0)),
                        url(${backgroundImg})
                      `,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                                height: '980px',
                                backgroundColor: '#3f3d45',
                                margin: '0 auto',
                                position: 'relative',
                                backgroundPosition: '50%'
                            }}>
                                <Grid className='container' style={{
                                    padding: 50,
                                    gap: '10px',
                                    justifyContent: 'center',
                                    overflow: 'scroll'


                                }}>
                                    <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 15 }}>
                                        <Typography style={{ color: 'white', fontWeight: 'bold', fontSize: '32px', fontFamily: 'Outfit,sans-serif', textAlign: 'center' }} >
                                            No estás habilitado para solicitar tipeo, lo tienes que ganar en algún sorteo realizado por el dengue!

                                        </Typography>
                                        <Typography sx={{
                                            background: 'linear-gradient(317deg,#b58a1b 4.52%,#e0c060 34.37%,#ffeeb2 50.47%,#ffe77c 65.63%,#ffca41 110.56%)',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                            fontWeight: 'bold',
                                            fontSize: props.isMobile ? 32 : 50,
                                            fontFamily: 'Belerofonte'
                                        }} >Eldenguee.com</Typography>
                                    </Grid>

                                    <Grid style={{ display: 'flex', alignItems: 'center', gap: '10px' }} >


                                        <Button

                                            sx={{
                                                color: 'black',
                                                fontWeight: 'bold',
                                                padding: '0.75rem 2rem',
                                                fontSize: '.8rem',
                                                fontFamily: 'Outfit,sans-serif',
                                                backgroundImage: `linear-gradient(317deg,#b58a1b 4.52%,#e0c060 34.37%,#ffeeb2 50.47%,#ffe77c 65.63%,#ffca41 110.56%)`,
                                                border: '2px solid #e0c060',
                                                borderRadius: '100px',
                                                boxShadow: '0 0 8px rgba(118, 118, 245, 0.8)',
                                                textTransform: 'uppercase',
                                                transition: 'all 0.3s ease-in-out',
                                                '&:hover': {
                                                    boxShadow: '0 0 16px rgba(118, 118, 245, 1)',
                                                    transform: 'scale(1.05)',
                                                },
                                            }}
                                            href='/'
                                        >
                                            Volver al inicio
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            :

                            <Grid style={{
                                backgroundImage: `
    linear-gradient(to bottom, rgba(63, 61, 69, 0.8), rgba(63, 61, 69, 0)),
    url(${backgroundImg})
  `,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',

                                backgroundColor: '#3f3d45',
                                margin: '0 auto',
                                position: 'relative',
                                backgroundPosition: '50%',
                                marginTop: props.isMobile ? '1%' : '5%'
                            }}>
                                <Grid className='container' style={{
                                    padding: props.isMobile ? 10 : 50,
                                    gap: '10px',
                                    justifyContent: 'center',
                                    overflow: 'scroll'


                                }}>
                                    <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 15 }}>


                                    </Grid>

                                    <Box sx={{ mx: 'auto', my: 1, mt: '8%' }}>
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                maxWidth: !props.isMobile ? 650 : '100%',
                                                margin: '0 auto',
                                                borderRadius: success ? 'none' : '16px',
                                                overflow: 'hidden',
                                                backgroundColor: success ? 'transparent' : '#0c1921',
                                                color: '#fff',
                                                p: props.isMobile ? 2 : 4,
                                                border: '1px solid #162f3f',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
                                            }}
                                        >
                                            {
                                                !success &&
                                                <>
                                                    {/* Header with Title and Help Button */}
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" fill="#22c55e" />
                                                                <path d="M14 2V8H20L14 2Z" fill="#15803d" />
                                                                <path d="M16 12H8V14H16V12Z" fill="white" />
                                                                <path d="M16 16H8V18H16V16Z" fill="white" />
                                                                <path d="M11 8H8V10H11V8Z" fill="white" />
                                                            </svg>
                                                            <Typography sx={{ fontWeight: 'bold', fontSize: '1.25rem', fontFamily: 'Outfit, sans-serif' }}>
                                                                Solicitud de tipeo
                                                            </Typography>
                                                        </Box>
                                                        <Button
                                                            variant="outlined"
                                                            size="small"
                                                            startIcon={
                                                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                                    <circle cx="12" cy="12" r="10"></circle>
                                                                    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                                                                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                                                </svg>
                                                            }
                                                            sx={{
                                                                color: '#94a3b8',
                                                                borderColor: 'rgba(148, 163, 184, 0.2)',
                                                                borderRadius: '999px',
                                                                textTransform: 'none',
                                                                fontSize: '0.75rem',
                                                                py: 0.5,
                                                                px: 1.5,
                                                                backgroundColor: 'rgba(30, 41, 59, 0.4)',
                                                                '&:hover': {
                                                                    borderColor: 'rgba(148, 163, 184, 0.4)',
                                                                    backgroundColor: 'rgba(30, 41, 59, 0.6)',
                                                                }
                                                            }}
                                                        >
                                                            ¿Necesitas ayuda?
                                                        </Button>
                                                    </Box>

                                                    {/* Progress Info and Progress Bar */}
                                                    <Box sx={{ mb: 4 }}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                                            <Typography sx={{ fontSize: '0.9rem', color: '#cbd5e1', fontWeight: '500' }}>
                                                                Paso <span style={{ color: '#22c55e', fontWeight: 'bold' }}>{activeStep + 1}</span> de {steps.length}
                                                            </Typography>
                                                            <Typography sx={{ fontSize: '0.9rem', color: '#22c55e', fontWeight: 'bold' }}>
                                                                {Math.round(((activeStep + 1) / steps.length) * 100)}%
                                                            </Typography>
                                                        </Box>
                                                        <Box sx={{ width: '100%', height: '6px', backgroundColor: '#101f28', borderRadius: '999px', overflow: 'hidden', border: '1px solid #1a2f3f' }}>
                                                            <Box
                                                                sx={{
                                                                    width: `${((activeStep + 1) / steps.length) * 100}%`,
                                                                    height: '100%',
                                                                    backgroundColor: '#22c55e',
                                                                    borderRadius: '999px',
                                                                    transition: 'width 0.4s ease-in-out',
                                                                    boxShadow: '0 0 8px rgba(34, 197, 94, 0.6)',
                                                                }}
                                                            />
                                                        </Box>
                                                    </Box>

                                                    {/* Custom circular stepper connecting line */}
                                                    {!props.isMobile && (
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'space-between',
                                                                position: 'relative',
                                                                mb: 4,
                                                                px: 1,
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    position: 'absolute',
                                                                    top: '16px',
                                                                    left: '24px',
                                                                    right: '24px',
                                                                    height: '2px',
                                                                    backgroundColor: '#1b3242',
                                                                    zIndex: 0,
                                                                }}
                                                            />
                                                            <Box
                                                                sx={{
                                                                    position: 'absolute',
                                                                    top: '16px',
                                                                    left: '24px',
                                                                    width: `${(activeStep / (steps.length - 1)) * 92}%`,
                                                                    height: '2px',
                                                                    backgroundColor: '#22c55e',
                                                                    zIndex: 0,
                                                                    transition: 'width 0.4s ease-in-out',
                                                                }}
                                                            />

                                                            {steps.map((label, index) => {
                                                                const isCompleted = index < activeStep;
                                                                const isActive = index === activeStep;
                                                                return (
                                                                    <Box
                                                                        key={label}
                                                                        sx={{
                                                                            display: 'flex',
                                                                            flexDirection: 'column',
                                                                            alignItems: 'center',
                                                                            position: 'relative',
                                                                            zIndex: 1,
                                                                            flexShrink: 0,
                                                                            width: '45px',
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            sx={{
                                                                                width: '32px',
                                                                                height: '32px',
                                                                                borderRadius: '50%',
                                                                                display: 'flex',
                                                                                alignItems: 'center',
                                                                                justifyContent: 'center',
                                                                                fontWeight: 'bold',
                                                                                fontSize: '0.8rem',
                                                                                transition: 'all 0.3s ease-in-out',
                                                                                backgroundColor: isActive
                                                                                    ? '#22c55e'
                                                                                    : isCompleted
                                                                                        ? '#101f28'
                                                                                        : '#0b131a',
                                                                                color: isActive
                                                                                    ? '#000'
                                                                                    : isCompleted
                                                                                        ? '#22c55e'
                                                                                        : '#475569',
                                                                                border: isActive
                                                                                    ? '2px solid #22c55e'
                                                                                    : isCompleted
                                                                                        ? '2px solid #22c55e'
                                                                                        : '2px solid #1c2d3b',
                                                                                boxShadow: isActive ? '0 0 12px rgba(34, 197, 94, 0.5)' : 'none',
                                                                            }}
                                                                        >
                                                                            {isCompleted ? '✓' : index + 1}
                                                                        </Box>
                                                                        <Typography
                                                                            sx={{
                                                                                mt: 1,
                                                                                fontSize: '0.65rem',
                                                                                fontWeight: isActive || isCompleted ? 'bold' : 'normal',
                                                                                color: isActive
                                                                                    ? '#22c55e'
                                                                                    : isCompleted
                                                                                        ? '#94a3b8'
                                                                                        : '#64748b',
                                                                                textAlign: 'center',
                                                                                whiteSpace: 'nowrap',
                                                                            }}
                                                                        >
                                                                            {label}
                                                                        </Typography>
                                                                    </Box>
                                                                );
                                                            })}
                                                        </Box>
                                                    )}
                                                </>
                                            }

                                            {success ? (
                                                <Box
                                                    sx={{
                                                        backgroundColor: '#0c1b26',
                                                        borderRadius: '12px',
                                                        padding: 3,
                                                        width: '80%',
                                                        margin: '0 auto',
                                                        textAlign: 'center',
                                                        color: 'white',
                                                    }}
                                                >
                                                    {/* Título con ícono y botón cerrar */}
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center',
                                                            mb: 2,
                                                        }}
                                                    >
                                                        <Typography sx={{ fontWeight: 'bold' }}>Solicitud de tipeo</Typography>
                                                        <Button sx={{ color: 'white' }} size="small">✕</Button>
                                                    </Box>

                                                    {/* Imagen */}
                                                    <Box sx={{ mb: 2 }}>
                                                        <img
                                                            src={successImg}// Colocá la ruta correcta a tu imagen
                                                            alt="Caja fuerte"
                                                            style={{ width: '100%', height: 'auto', margin: '0 auto' }}
                                                        />
                                                    </Box>

                                                    {/* Mensaje principal */}
                                                    <Typography sx={{ fontSize: '1.2rem', fontWeight: 'bold', mb: 2 }}>
                                                        ¡Se completó tu solicitud de tipeo!
                                                    </Typography>

                                                    {/* Cuadro con correo */}
                                                    <Paper
                                                        elevation={0}
                                                        sx={{
                                                            backgroundColor: '#15232f',
                                                            color: 'white',
                                                            padding: 2,
                                                            borderRadius: '8px',
                                                            mb: 3,
                                                        }}
                                                        style={{ border: '2px dashed #2a2e38' }}
                                                    >
                                                        <Typography sx={{ fontSize: '0.9rem', textAlign: 'left' }}>
                                                            Cuando tu tipeo esté listo te llegará un correo a:
                                                        </Typography>
                                                        <Typography sx={{ fontWeight: 'bold', mt: 1, textAlign: 'left' }}>
                                                            {userEmail}
                                                        </Typography>

                                                    </Paper>
                                                    <Box style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '5px' }}>

                                                        <Typography sx={{ fontSize: '0.9rem', textAlign: 'left' }}>
                                                            Dirección de retiro:
                                                        </Typography>
                                                        <Typography sx={{ fontWeight: 'bold', mt: 1, textAlign: 'left' }}>
                                                            {bnbAddress}
                                                        </Typography>
                                                    </Box>

                                                    {/* Botón */}
                                                    <Button
                                                        fullWidth
                                                        variant="contained"
                                                        sx={{
                                                            backgroundColor: '#007bff',
                                                            borderRadius: '8px',
                                                            textTransform: 'none',
                                                            fontWeight: 'bold',
                                                            '&:hover': {
                                                                backgroundColor: '#0066d6',
                                                            },
                                                        }}
                                                        onClick={redirectHome}
                                                    >
                                                        Listo
                                                    </Button>
                                                </Box>
                                            ) : (
                                                <>
                                                    {error && (
                                                        <Alert severity="error" sx={{ mb: 2 }}>
                                                            {error}
                                                        </Alert>
                                                    )}
                                                    <Box
                                                        sx={{
                                                            height: props.isMobile ? '600px' : '520px',
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "space-between",
                                                        }}
                                                    >
                                                        {getStepContent(activeStep)}
                                                    </Box>

                                                    <Box style={{ display: 'flex', gap: '15px', marginTop: '20px' }}>
                                                        <Button
                                                            disabled={activeStep === 0 || loading}
                                                            onClick={handleBack}
                                                            variant="outlined"
                                                            style={{ width: '50%' }}
                                                            sx={{
                                                                color: '#cbd5e1',
                                                                borderColor: '#334155',
                                                                backgroundColor: 'rgba(30, 41, 59, 0.3)',
                                                                textTransform: 'none',
                                                                fontWeight: 'bold',
                                                                py: 1.2,
                                                                borderRadius: '8px',
                                                                '&:hover': {
                                                                    borderColor: '#475569',
                                                                    backgroundColor: 'rgba(30, 41, 59, 0.5)',
                                                                },
                                                                '&.Mui-disabled': {
                                                                    color: '#475569',
                                                                    borderColor: '#1e293b',
                                                                }
                                                            }}
                                                        >
                                                            ← Atrás
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            disabled={loading}
                                                            onClick={activeStep === steps.length - 1 ? handleRequestTipeo : handleNext}
                                                            sx={{
                                                                width: '50%',
                                                                backgroundColor: '#22c55e',
                                                                color: 'white',
                                                                textTransform: 'none',
                                                                fontWeight: 'bold',
                                                                py: 1.2,
                                                                borderRadius: '8px',
                                                                '&:hover': {
                                                                    backgroundColor: '#16a34a',
                                                                },
                                                                '&.Mui-disabled': {
                                                                    backgroundColor: '#14532d',
                                                                    color: '#4ade80',
                                                                }
                                                            }}
                                                        >
                                                            {loading ? (
                                                                <CircularProgress size={24} color="inherit" />
                                                            ) : activeStep === steps.length - 1 ? (
                                                                'Terminar'
                                                            ) : (
                                                                'Siguiente →'
                                                            )}
                                                        </Button>
                                                    </Box>

                                                    {isOpen && selectedImage && (
                                                        <div
                                                            style={{
                                                                position: 'fixed',
                                                                top: 0,
                                                                left: 0,
                                                                width: '100vw',
                                                                height: '100vh',
                                                                backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                zIndex: 99999,
                                                            }}
                                                        >
                                                            {/* Botón X para cerrar */}
                                                            <button
                                                                onClick={closeImage}
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: 20,
                                                                    right: 20,
                                                                    background: 'transparent',
                                                                    border: 'none',
                                                                    fontSize: '32px',
                                                                    color: '#fff',
                                                                    cursor: 'pointer',
                                                                    zIndex: 99999,
                                                                }}
                                                                aria-label="Cerrar visor"
                                                            >
                                                                &times;
                                                            </button>

                                                            {/* Imagen ampliada */}
                                                            <img
                                                                src={selectedImage}
                                                                alt="Expanded"
                                                                style={{
                                                                    maxWidth: '90%',
                                                                    maxHeight: '90%',
                                                                    borderRadius: 10,
                                                                    boxShadow: '0 0 20px rgba(0,0,0,0.5)',
                                                                }}
                                                                onClick={(e) => e.stopPropagation()} // evita que se cierre al hacer click sobre la imagen
                                                            />
                                                        </div>
                                                    )}
                                                    {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                                                {
                                                    activeStep !== 0 &&
                                                    <Button
                                                        disabled={activeStep === 0 || loading}
                                                        onClick={handleBack}
                                                        variant="outlined"
                                                    >
                                                        Atrás
                                                    </Button>
                                                }

                                                <Button
                                                    onClick={activeStep === steps.length - 1 ? handleRequestTipeo : handleNext}
                                                    variant="contained"
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <CircularProgress size={24} />
                                                    ) : activeStep === steps.length - 1 ? (
                                                        'Terminar solicitud'
                                                    ) : (
                                                        'Siguiente'
                                                    )}
                                                </Button> 
                                            </Box> */}
                                                </>
                                            )}
                                        </Paper>
                                    </Box>
                                </Grid>
                            </Grid>
                }

                <Dialog
                    open={showWarningModal}
                    onClose={() => setShowWarningModal(false)}
                    PaperProps={{
                        style: {
                            backgroundColor: '#0f172a',
                            color: 'white',
                            padding: '20px',
                            borderRadius: '10px',
                            textAlign: 'center',
                            maxWidth: '400px',
                        },
                    }}
                >
                    <Typography sx={{ fontWeight: 'bold', mb: 2 }}>
                        ⚠️ IMPORTANTE
                    </Typography>

                    <Typography sx={{ mb: 3 }}>
                        LA IMAGEN TIENE QUE SER TOMADA EL DÍA DE HOY Y NO TIENE QUE ESTAR RECORTADA.
                        EN CASO CONTRARIO EL SISTEMA DENEGARÁ LA SOLICITUD.
                    </Typography>

                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                        <Button
                            variant="contained"
                            onClick={() => {
                                setShowWarningModal(false);
                                if (triggerUpload) triggerUpload(); // abre input de imagen
                            }}
                            sx={{ backgroundColor: '#22c55e', '&:hover': { backgroundColor: '#16a34a' } }}
                        >
                            Aceptar
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => setShowWarningModal(false)}
                            sx={{ backgroundColor: '#ef4444', '&:hover': { backgroundColor: '#dc2626' } }}
                        >
                            Cancelar
                        </Button>
                    </Box>
                </Dialog>
            </Grid>
        </Nlayout>
    )
}

export default BetWinner



